export default __webpack_public_path__ + "static/media/refuel.dec20137.jpg";